
<template>
  <div class="commonBanner">
    <img :src="special == null ?  banner_path: special.background_path" alt />
  </div>
</template>


<script>
import {postDataJxjy} from "@/assets/api/api";

export default {
  name: "commonBanner",
  components: {},
  data() {
    return {
      special: null,
      banner_path: "https://jxjy.aierxin.cn/uploads/banner/banner333.jpg"
    };
  },
  created() {
    this.special = JSON.parse(localStorage.getItem("special"))
    postDataJxjy("/jxjyapi/index/getBannerPath", ).then((res) => {
      console.log(res, 888);
      if (res.code == false) {


      } else {
        this.banner_path = res.data.path;
      }

    })
  },
  mounted() {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.commonBanner {
  padding-bottom: 20px;
  img{
      display: block;
      width: 100%;
      height: 280px;
  }
}
</style>